import Vue from 'vue'
import upperFirst from 'lodash/upperFirst'
import camelCase from 'lodash/camelCase'
import InputSelecionaBanco from 'core/components/InputSelecionaBanco.vue'
import ComprovantePagamentoModal from 'core/components/ComprovantePagamentoModal.vue'
import DadosEndereco from 'core/components/DadosEndereco.vue'
import DadosContato from 'core/components/DadosContato.vue'
import DocumentoEdit from 'core/components/DocumentoEdit.vue'
import DocumentoModal from 'core/components/DocumentoModal.vue'
import AgendaParcela from 'core/components/AgendaParcela.vue'

const requireComponent = require.context('/', true, /\.vue$/)

requireComponent.keys().forEach(fileName => {
  if (fileName.indexOf('AppLayout') < 0) {
    const componentConfig = requireComponent(fileName)

    const componentName = upperFirst(
      camelCase(fileName.replace(/^\.\//, '').replace(/\.\w+$/, ''))
    )

    Vue.component(componentName, componentConfig.default || componentConfig)
  }
})
Vue.component('InputSelecionaBanco', InputSelecionaBanco)
Vue.component('ComprovantePagamentoModal', ComprovantePagamentoModal)
Vue.component('DadosEndereco', DadosEndereco)
Vue.component('DadosContato', DadosContato)
Vue.component('DocumentoEdit', DocumentoEdit)
Vue.component('DocumentoModal', DocumentoModal)
Vue.component('AgendaParcela', AgendaParcela)
